import { useState } from "react";
import styles from "./SAKConfirmationHeader.module.css";

interface SAKConfirmationHeaderProps {
  visible?: boolean;
  photoUrl: string;
  childName: string;
}

export function SAKConfirmationHeader({
  visible = true,
  photoUrl,
  childName
}: SAKConfirmationHeaderProps) {
  const [confettiActive, setConfettiActive] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);

  if (!visible) return null;

  const handlePhotoLoad = () => {
    // Trigger confetti when the image is loaded
    setConfettiActive(true);
    // Make the photo visible
    setHasLoaded(true);
  };

  const handlePhotoClick = () => {
    // Reset and retrigger the confetti animation when the photo is clicked
    setConfettiActive(false);
    requestAnimationFrame(() => {
      setConfettiActive(true);
    });
  };

  return (
    <div className={`${styles.header} ${confettiActive ? styles.showConfetti : ""}`}>
      <div className={`${styles.photoWrapper} ${!hasLoaded ? styles.hidden : ""}`}>
        <img
          src={photoUrl}
          alt={childName || "Your sponsored child"}
          className={styles.photo}
          onLoad={handlePhotoLoad}
          onClick={handlePhotoClick}
          width={142.5}
          height={190}
        />
      </div>
    </div>
  );
}

export default SAKConfirmationHeader;
